import { render, staticRenderFns } from "./SongkranRanking.vue?vue&type=template&id=5c771ed6&scoped=true&"
import script from "./SongkranRanking.vue?vue&type=script&lang=js&"
export * from "./SongkranRanking.vue?vue&type=script&lang=js&"
import style0 from "./SongkranRanking.vue?vue&type=style&index=0&id=5c771ed6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c771ed6",
  null
  
)

export default component.exports